export const PROFILE_MENU_HIDDEN_KEY = "hideProfileMenu";

export const hideProfileSideMenu = () => {
  sessionStorage.setItem(PROFILE_MENU_HIDDEN_KEY, "true");
};

export const showProfileSideMenu = () => {
  sessionStorage.removeItem(PROFILE_MENU_HIDDEN_KEY);
};

export const isProfileSideMenuHidden = () =>
  sessionStorage.getItem(PROFILE_MENU_HIDDEN_KEY) === "true";
